import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IRemoteCommunication } from 'projects/common/src/app/interfaces/communication';
import { Observable } from 'rxjs';
import { IRequestCancellable } from 'projects/common/src/app/interfaces/communication/request';

/**
 * Implementación de servicio de communicación para el proyecto actual
 *
 * El servicio que lo implemente debe respetar la interfaz crud y crud cancelable
 * del proyecto de communication
 */
@Injectable({
  providedIn: 'root'
})
export class CommunicationSecurityService implements IRemoteCommunication {

  constructor(
    http: HttpClient,
    host?: string,
    port?: string,
  ) { }

  get: (...arg) => Observable<any>;
  post: (...arg) => Observable<any>;
  patch: (...arg) => Observable<any>;
  delete: (...arg) => Observable<any>;
  getCancellable: (...arg) => IRequestCancellable;
  postCancellable: (...arg) => IRequestCancellable;
  patchCancellable: (...arg) => IRequestCancellable;
  deleteCancellable: (...arg) => IRequestCancellable;
}